import Button from '@/components/Buttons/Button';
import styled from '@emotion/styled';
import { Typography, useTheme } from '@mui/material';
import { PromptContainer } from './common';
import error from './images/error.svg';
import retry from './images/retry.svg';

const MainContainer = styled.div``;

const GreyContainer = styled(PromptContainer)`
    height: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 65px;
`;

const TryAgainButton = styled(Button)`
    margin: 32px auto 0 auto;
    padding: 24px;
    font-size: 18px;
`;

const Icon = styled.img`
    margin-bottom: 16px;
`;

const Title = styled(Typography)`
    margin-bottom: 12px;
`;

interface Props {
    onTryAgain?: () => void;
    title: string;
    subtitle?: string;
}

function ErrorDialogContent({ onTryAgain, title, subtitle }: Props) {
    const theme = useTheme();

    return (
        <MainContainer>
            <GreyContainer>
                <Icon src={error} />
                <Title variant="body1" fontWeight={600} letterSpacing={0.17} lineHeight="normal">
                    {title}
                </Title>
                <Typography
                    variant="body1"
                    fontWeight={400}
                    letterSpacing={0.15}
                    width={300}
                    lineHeight="normal"
                    textAlign="center"
                    color={theme.colors.secondary[700]}>
                    {subtitle}
                </Typography>
            </GreyContainer>
            {onTryAgain && (
                <TryAgainButton startIcon={<img src={retry} />} onClick={onTryAgain}>
                    Try again
                </TryAgainButton>
            )}
        </MainContainer>
    );
}

export default ErrorDialogContent;
